import React, { useState } from 'react';

const CollapsedSection = function ({className, open, tag, label, togglerLabel, children}) {
  const [isOpen, toggleOpen] = useState(open)
  const Tag = tag || 'div'

  return (
    <Tag className={`collapsed-section ${className} ${isOpen ? 'open' : ''}`}>
      <button type="button" className="collapsed-section__toggler" onClick={() => toggleOpen(!isOpen)}>
        <span className="collapsed-section__label">{label}</span>
        <span className="collapsed-section__toggler-status">{togglerLabel}</span>
      </button>
      <div className="collapsed-section__body">
        {children}
      </div>
    </Tag>
  )
}

export default CollapsedSection
